import React from "react";

const Titles = () => (
	<div className="container-fluid">
		<div>
			<h1 className="title-container__title">The GetWeather App</h1>
		</div>
		<div>
			<h3 className="title-container__subtitle">Get latest temperature, conditions and more... right here</h3>
		</div>
		<div>
			<footer>By @SujoyDutta</footer>
		</div>
	</div>
);

export default Titles;